import { Box, Divider, Grid, styled, Typography } from '@mui/material';

export const TitleGridContainer = styled(Box)`
  margin-top: 16px;
  margin-bottom: 24px;
`;

export const TitleTypography = styled(Box)`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  text-transform: capitalize;
  color: #0f1111;
  margin-bottom: 16px;
  text-align: left;
`;

export const BasicTitleTypography = styled(Typography)`
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  text-transform: capitalize;
  color: #0f1111;
  width: 50%;
`;

export const ValueTypography = styled(Typography)`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #0f1111;
  width: 50%;
`;

export const DividerStyled = styled(Divider)`
  margin: -1px;
  margin-top: 8px;
`;

export const FlexGrid = styled(Grid)`
  display: flex;
`;
